import Player from "@vimeo/player";

export default class Livestream {
  constructor(node) {
    this.element = node;
    this.chatWrapper = this.element.querySelector(".js-livestream-chat-wrapper");
    this.livestreamWrapper = this.element.querySelector(".js-livestream-wrapper");
    this.loadingWrapper = this.element.querySelector(".js-livestream-loading-wrapper");
    this.iframeTemplate = this.element.querySelector(".js-livestream-iframe-template");

    this.vimeoUrl = this.element.dataset.livestreamUrl;
    this.chatUrl = this.element.dataset.livestreamChatUrl;

    this.intialize();
  }

  intialize() {
    if (this.chatUrl) {
      this.detailsWrapper = this.element.querySelector(".js-livestream-details-wrapper");
      this.detailsWrapper.classList.add("is-loading");
      this.createChat();
    }

    this.createPlayer();

    this.player = new Player(this.iframe);

    this.player
      .ready()
      .then(() => {
        this.loadingWrapper.remove();
      })
      .finally(() => {
        this.livestreamWrapper.classList.remove("d-none");

        if (this.chatUrl) {
          this.detailsWrapper.classList.remove("is-loading");
        }
      });
  }

  createChat() {
    const chatIframe = document.createElement("iframe");
    chatIframe.src = this.chatUrl;
    chatIframe.width = "100%";
    chatIframe.height = "700px";

    this.chatWrapper.innerHTML = "";
    this.chatWrapper.insertAdjacentElement("beforeend", chatIframe);
  }

  createPlayer() {
    const iframe = this.iframeTemplate.content.cloneNode(true);

    this.livestreamWrapper.appendChild(iframe);
    this.iframeTemplate.remove();

    this.iframe = this.livestreamWrapper.querySelector("iframe");
    this.iframe.src = this.vimeoUrl;
  }
}
